export type DepartureTimeRange = 'morning' | 'afternoon' | 'evening';

const MORNING_START = 6;
const AFTERNOON_START = 12;
const EVENING_START = 18;

const TIME_RANGE_HOURS: Record<DepartureTimeRange, [number, number]> = {
  morning: [MORNING_START, AFTERNOON_START - 1],
  afternoon: [AFTERNOON_START, EVENING_START - 1],
  evening: [EVENING_START, MORNING_START - 1],
};

/** Checks whether a given hour (0–23) falls within the specified time range. */
export function matchesTimeRange(hour: number, range: DepartureTimeRange): boolean {
  const [start, end] = TIME_RANGE_HOURS[range];

  // Evening wraps around midnight: 18–23 and 0–5
  if (start > end) {
    return hour >= start || hour <= end;
  }

  return hour >= start && hour <= end;
}
